import api, { ApiResponse } from './api';

export interface Location {
  id: number;
  name: string;
  code?: string;
  description?: string;
  address?: string;
  floor?: string;
  building?: string;
  zone?: string;
  siteId?: number | null;
  isActive: boolean;
}

export interface LocationDropdownItem {
  id: number;
  name: string;
  code?: string;
}

export interface LocationCreateDto {
  name: string;
  code?: string;
  description?: string;
  address?: string;
  floor?: string;
  building?: string;
  zone?: string;
  siteId?: number | null;
}

export interface LocationUpdateDto {
  name?: string;
  code?: string;
  description?: string;
  address?: string;
  floor?: string;
  building?: string;
  zone?: string;
  siteId?: number | null;
  isActive?: boolean;
}

const locationService = {
  getAll: async (activeOnly: boolean = false): Promise<ApiResponse<Location[]>> => {
    const params = activeOnly ? '?activeOnly=true' : '';
    return api.get(`/locations${params}`);
  },

  getById: async (id: number): Promise<ApiResponse<Location>> => {
    return api.get(`/locations/${id}`);
  },

  create: async (data: LocationCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/locations', data);
  },

  update: async (id: number, data: LocationUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/locations/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/locations/${id}`);
  },

  getForDropdown: async (): Promise<ApiResponse<LocationDropdownItem[]>> => {
    return api.get('/locations/dropdown');
  },
};

export default locationService;
